var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: "企业采购" } }, [
    _vm.purchaseAuthority
      ? _c(
          "div",
          { staticClass: "trade" },
          [
            _c("div", { staticClass: "clearfix order" }, [
              _c("div", { staticClass: "left" }, [
                _c("div", { staticClass: "f16 title" }, [_vm._v("企业订单")]),
                _c("ul", { staticClass: "ul-cls order-list" }, [
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "v/order/list?appid=1&tabId=1&isShowTitle=1",
                            "待支付-企业订单"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.orderNums.dzfOrderNum,
                            max: 99,
                            hidden:
                              !_vm.orderNums.dzfOrderNum ||
                              _vm.orderNums.dzfOrderNum === 0
                          }
                        },
                        [
                          _c(
                            "a",
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "待支付" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("a", [_vm._v("待支付")])
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "v/order/list?appid=1&tabId=2&isShowTitle=1",
                            "待发货-企业订单"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.orderNums.orderStatus2,
                            max: 99,
                            hidden:
                              !_vm.orderNums.orderStatus2 ||
                              _vm.orderNums.orderStatus2 === 0
                          }
                        },
                        [
                          _c(
                            "a",
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "待发货" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("a", [_vm._v("待发货")])
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "v/order/list?appid=1&tabId=3&isShowTitle=1",
                            "待收货-企业订单"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.orderNums.orderStatus3,
                            max: 99,
                            hidden:
                              !_vm.orderNums.orderStatus3 ||
                              _vm.orderNums.orderStatus3 === 0
                          }
                        },
                        [
                          _c(
                            "a",
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "待收货" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("a", [_vm._v("待收货")])
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "v/order/list?appid=1&tabId=4&isShowTitle=1",
                            "待评价-企业订单"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.orderNums.orderStatus4,
                            max: 99,
                            hidden:
                              !_vm.orderNums.orderStatus4 ||
                              _vm.orderNums.orderStatus4 === 0
                          }
                        },
                        [
                          _c(
                            "a",
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "待评价" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("a", [_vm._v("待评价")])
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "v/aftersales/orderList?appid=1&isShowTitle=1",
                            "售后-企业订单"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.orderNums.refundStatusCount,
                            max: 99,
                            hidden:
                              !_vm.orderNums.refundStatusCount ||
                              _vm.orderNums.refundStatusCount === 0
                          }
                        },
                        [
                          _c(
                            "a",
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "售后" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("a", [_vm._v("售后")])
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "v/order/list?appid=1&tabId=0&isShowTitle=1",
                            "企业订单"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "a",
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "全部订单" }
                          })
                        ],
                        1
                      ),
                      _c("a", [_vm._v("全部订单")])
                    ]
                  ),
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.open(
                            "cart/selectCart.do?appid=1",
                            "进货车",
                            1
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.shoppingNum,
                            max: 99,
                            hidden: _vm.shoppingNum == 0
                          }
                        },
                        [
                          _c(
                            "a",
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "购物车2" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("a", [_vm._v("进货车")])
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "right" }, [
                _c(
                  "div",
                  { staticClass: "clearfix" },
                  [
                    _c("ul", { staticClass: "ul-cls f16 pointer pull-left" }, [
                      _c(
                        "li",
                        { class: { active: _vm.favoriteClass === 1 } },
                        [
                          _vm.favorite.shopNums === 0
                            ? [_vm._v("推荐店铺")]
                            : [
                                _vm._v(
                                  "关注店铺 [" +
                                    _vm._s(_vm.favorite.shopNums) +
                                    "]"
                                )
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm.favoriteClass === 0
                      ? [
                          _vm.favorite.goodsNums === 0
                            ? _c(
                                "a",
                                {
                                  staticClass: "pull-right blue more",
                                  attrs: {
                                    target: "_blank",
                                    href: _vm.origin.VUE_APP_APP
                                  }
                                },
                                [_vm._v("更多 >")]
                              )
                            : _vm._e()
                        ]
                      : [
                          _vm.favorite.goodsNums === 0
                            ? _c(
                                "a",
                                {
                                  staticClass: "pull-right blue more",
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      _vm.origin.VUE_APP_APP +
                                      "goods/toShopList.do"
                                  }
                                },
                                [_vm._v("更多 >")]
                              )
                            : _vm._e()
                        ]
                  ],
                  2
                ),
                _vm.favoriteClass === 0
                  ? _c(
                      "div",
                      { staticClass: "favorite-list" },
                      _vm._l(_vm.goodList, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.goodsId || item.goodsEntity.goodsId,
                            staticClass: "text-center item"
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "" + _vm.goodDetailUrl + item.goodsId,
                                  target: "_blank"
                                }
                              },
                              [
                                item.goodsUrl
                                  ? _c("img", {
                                      attrs: {
                                        title: item.goodsName,
                                        src:
                                          item.goodsUrl +
                                          "?imageView2/1/w/90/h/90"
                                      }
                                    })
                                  : _c("img", {
                                      attrs: {
                                        src: require("./images/goods.png"),
                                        title: item.goodsName
                                      }
                                    })
                              ]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "text-left text-overflow-2 text",
                                attrs: {
                                  href: "" + _vm.goodDetailUrl + item.goodsId,
                                  target: "_blank",
                                  title: item.goodsName
                                }
                              },
                              [_vm._v(_vm._s(item.goodsName))]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      { staticClass: "favorite-list" },
                      _vm._l(_vm.favorite.shopList, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.shopIds || item.shopEntity.shopIdStr,
                            staticClass: "text-center item pointer",
                            on: {
                              click: function($event) {
                                return _vm.openLink(item)
                              }
                            }
                          },
                          [
                            item.shopIds
                              ? [
                                  _c("a", [
                                    item.face
                                      ? _c("img", {
                                          staticStyle: { height: "90px" },
                                          attrs: {
                                            title: item.name,
                                            src:
                                              item.face +
                                              "?imageView2/1/w/90/h/90"
                                          }
                                        })
                                      : _c("img", {
                                          staticStyle: { height: "90px" },
                                          attrs: {
                                            title: item.name,
                                            src: require("./images/shop.png")
                                          }
                                        })
                                  ]),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-overflow-2 text",
                                      attrs: { title: item.name }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      0
                    )
              ])
            ]),
            _c("goodList")
          ],
          1
        )
      : _c("div", { staticClass: "pad50-tb text-center f16" }, [
          _c("i", { staticClass: "el-icon-warning-outline mar10-r" }),
          _c("span", [
            _vm._v("抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限")
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }